/** Shared world projection dimensions; independent of world orchestration. */
export const TILE = { width: 192, height: 96 };
